import {
  Select,
  SelectContent,
  SelectGroup,
  SelectTrigger,
  SelectItem,
} from '@/components/ui/select';
import { DatePickerFormField } from '@/domain/termine/features/CreateTermin/Sheet/components/FormFields/DatePickerFormField';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';

import {
  getWiederholungStringFromTerminWiederholung,
  TerminWiederholung,
} from '@/domain/termine/shared/types/TerminWiederholung';
import { UseFormReturn } from 'react-hook-form';

export default function RepetitionInterval({
  value,
  onChange,
  form,
}: {
  value: TerminWiederholung;
  onChange: (value: TerminWiederholung) => void;
  form: UseFormReturn<FormValues>;
}) {
  return (
    <>
      <div className="pb-3">
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger className="border-neutrals-N300 w-full">
            <div>{getWiederholungStringFromTerminWiederholung(value)}</div>
          </SelectTrigger>
          <SelectContent className="border-none overflow-visible ">
            <SelectGroup>
              {Object.values(TerminWiederholung).map((enumValue) => (
                <SelectItem key={enumValue} value={enumValue}>
                  {getWiederholungStringFromTerminWiederholung(enumValue)}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
      {value !== TerminWiederholung.OHNE && (
        <DatePickerFormField form={form} name="wiederholungBis" />
      )}
    </>
  );
}
